import React, { useEffect, useState } from "react";
import "../styles/WelcomeScreen.css";
import logo from "../Assets/logo.svg";

const WelcomeScreen = ({ onFinish }) => {
  const [visible, setVisible] = useState(true);
  const [textAnimation, setTextAnimation] = useState(false);

  useEffect(() => {
    // Start text animation after a short delay
    const textTimer = setTimeout(() => {
      setTextAnimation(true);
    }, 500);

    // Hide welcome screen after 5 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
      onFinish();
    }, 3000);

    return () => {
      clearTimeout(textTimer);
      clearTimeout(hideTimer);
    };
  }, [onFinish]);

  if (!visible) return null;

  return (
    <div className="welcome-screen">
      {/* Animated background with color waves */}
      <div className="welcome-background">
        <div className="color-wave color-1"></div>
        <div className="color-wave color-2"></div>
        <div className="color-wave color-3"></div>
      </div>
      
      <div className="welcome-content">
        {/* Logo */}
        <div className="welcome-logo">
          <img src={logo} alt="Lite Grocer Logo" className="logo-image" />
        </div>
        
        {/* Animated Text */}
        <h1 className={`welcome-text ${textAnimation ? "animate" : ""}`}>
          <span className="text-part">Lite</span>
          <span className="text-part">Grocer</span>
          <span className="text-part">Web</span>
          <span className="text-part">Store</span>
        </h1>
        
        {/* Loading animation */}
        <div className="loading-container">
          <div className="loading-bar">
            <div className="loading-progress"></div>
          </div>
          <p className="loading-text">Loading your shopping experience...</p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;